




























































import {
  computed,
  defineComponent,
  PropType,
  ref,
  useContext,
  useRouter,
} from "@nuxtjs/composition-api"

import { updateUserFiles } from "@/api/query/userQuery"
import ImagePreview from "@/components/ImagePreview.vue"
import { Roles } from "@/enums"

export default defineComponent({
  components: { ImagePreview },
  props: {
    userId: {
      type: Number,
      required: true,
    },
    enabled: {
      type: Boolean,
      required: true,
    },
    showRing: {
      type: Boolean,
      default: false,
    },
    canEdit: {
      type: Boolean,
      default: false,
    },
    role: {
      type: String as PropType<Roles>,
      required: true,
    },
  },
  setup(props) {
    const { app } = useContext()
    const router = useRouter()
    const defaultProfessionalPhoto = require("~/assets/images/doc_pic.jpg")
    const defaultCustomerPhoto = require("~/assets/images/avatar-icon.svg")

    const avatar =
      app.$config.API_BASE_URL +
      app.$enums.ApiPaths.GET_AVATAR.replace(":userId", props.userId.toString())
        .replace("WIDTH", "120")
        .replace("HEIGHT", "120")

    const defaultPhoto =
      props.role === Roles.PROFESSIONAL
        ? defaultProfessionalPhoto
        : defaultCustomerPhoto ?? avatar

    const filePicker = ref<HTMLInputElement>()

    const { mutate: uploadFile, isLoading: avatarUploading } = updateUserFiles({
      onSuccess: () => {
        router.go(0)
      },
    })

    const disableAvatarClick = computed(() => {
      return avatarUploading.value
    })

    const isLoading = computed(() => {
      return avatarUploading.value
    })

    const openFilePicker = () => {
      if (disableAvatarClick.value) return
      if (!filePicker.value) return

      filePicker.value.accept = "image/png, image/jpeg, image/jpg"
      filePicker.value.click()
    }

    const handleFilePickerChange = (e: Event) => {
      const target = e.target as HTMLInputElement

      const files = target.files

      if (!files || files.length < 1) return

      const file = files[0]

      uploadFile({
        fileName: app.$enums.UserFileNames.AVATAR,
        file,
      })
    }

    const showPreviewModal = ref(false)

    return {
      avatar,
      isLoading,
      avatarUploading,
      defaultPhoto,
      disableAvatarClick,
      openFilePicker,
      handleFilePickerChange,
      filePicker,
      showPreviewModal,
    }
  },
})
